import React from 'react';
import { gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const mutation = gql`
  mutation DeleteUserFilter($input: UserFilterDeleteInput!) {
    deleteUserFilter(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/DeleteUserFilter').type;

export const useDeleteUserFilter = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) => {
      if (!options.variables.input.cloudId) {
        throw new Error('variable "cloudId" is required in useDeleteTemplate');
      }
      return _mutate({
        context: { service: 'users' },
        update(cache) {
          const { cloudId } = options.variables.input;
          const id = cache.identify({ __typename: 'UserFilter', cloudId });
          cache.evict({ id });
        },
        ...options,
      });
    },
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
